import React, { Component } from "react";
import ExperienceOverlay from "./ExperienceOverlay";
import {
  normalizePresentation,
  presentationScopeKey,
  shouldShowClientSide,
} from "./experienceHelpers";

/**
 * Gates children until destination experience completes (or is skipped / none).
 * Frequency / dismissal handled via presentation.behavior + durable helpers.
 */
class ExperienceGate extends Component {
  constructor(props) {
    super(props);
    const presentation = normalizePresentation(props.presentation);
    const show =
      !props.disabled &&
      shouldShowClientSide(presentation, props.destinationType);

    this.state = {
      active: show,
    };
  }

  componentDidUpdate(prevProps) {
    const prevPresentation = normalizePresentation(prevProps.presentation);
    const presentation = normalizePresentation(this.props.presentation);
    const prevScope = presentationScopeKey(
      prevProps.destinationType,
      prevPresentation
    );
    const nextScope = presentationScopeKey(
      this.props.destinationType,
      presentation
    );

    if (
      prevProps.presentation !== this.props.presentation ||
      prevProps.disabled !== this.props.disabled ||
      prevProps.destinationType !== this.props.destinationType ||
      prevScope !== nextScope
    ) {
      const show =
        !this.props.disabled &&
        shouldShowClientSide(presentation, this.props.destinationType);
      if (show !== this.state.active) {
        this.setState({ active: show });
      }
    }
  }

  handleComplete = (reason) => {
    this.setState({ active: false });
    if (typeof this.props.onComplete === "function") {
      this.props.onComplete(reason);
    }
  };

  render() {
    const presentation = normalizePresentation(this.props.presentation);
    const overlayKey = presentationScopeKey(
      this.props.destinationType,
      presentation
    );

    return (
      <React.Fragment>
        {this.state.active ? (
          <ExperienceOverlay
            key={overlayKey}
            presentation={presentation}
            destinationType={this.props.destinationType}
            onComplete={this.handleComplete}
          />
        ) : null}
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default ExperienceGate;
